// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__Jrfhs","box":"modal_box__WBkwf"};